/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNaivesBayes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-7-4a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14-2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM12 2a2.998 2.998 0 0 1 1 5.825v3.472l1.241-1.448 1.519 1.302-3 3.5a1.001 1.001 0 0 1-1.519 0l-3-3.5L9.76 9.85 11 11.296v-3.47A2.998 2.998 0 0 1 12 2zM7.707 7.707 5.414 9.999 7.001 10 7 12.001 3 12a1.001 1.001 0 0 1-1-1V7h2v1.585l2.293-2.292zM20 8.562v-1.57h2v4a1 1 0 0 1-1 1h-4v-2h1.6l-2.276-2.297 1.422-1.408z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNaivesBayes as NaivesBayes };
